import { addSubscriptions } from './dispatchers';
import { dataMultiLoader } from '../../web/utilities/dataLoader';

export function initialise(dispatch) {
  const initialSubscriptionsDataObjects = dataMultiLoader(
    'redux-subscriptions'
  );
  initialSubscriptionsDataObjects.map((initialSubscriptionsData) => {
    return dispatch(addSubscriptions(initialSubscriptionsData));
  });
}
